import Component from "gia/Component";

export default class Module extends Component {
  mount() {
    this.DOM = {};
    this.DOM.view = this.element;

    this.morph();
  }

  morph() {
    const getText = this.DOM.view.getAttribute("data-href");
    let morphText = getText
      .replace("[AT]", "@")
      .replace("[DOT]", ".")
      .replace("[DOT]", ".");
    this.DOM.view.setAttribute("href", "mailto:" + morphText);
  }

  unmount() {}
}
